import { render, staticRenderFns } from "./ImportBordereauPartenaires.vue?vue&type=template&id=c4765906&"
import script from "./ImportBordereauPartenaires.vue?vue&type=script&lang=js&"
export * from "./ImportBordereauPartenaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports